import { create } from "lodash";
import {
  METHOD_API,
  createConnector,
  getParamsHelp,
  prefixApi,
} from "./Connector";

export const getListImportLog = (
  activity_base_id: string,
  last_key: string,
) => {
  return createConnector(
    METHOD_API.GET,
    `${prefixApi}/get-list-import-log?${getParamsHelp({
      activity_base_id: activity_base_id,
      last_key: last_key,
    })}`,
    null,
  );
};

export const getListExportLog = (
  activity_base_id: string,
  last_key: string,
) => {
  return createConnector(
    METHOD_API.GET,
    `${prefixApi}/get-list-export-log?${getParamsHelp({
      activity_base_id: activity_base_id,
      last_key: last_key,
    })}`,
    null,
  );
};

export const insertLogApi = (dataBody: any) => {
  return createConnector(
    METHOD_API.UPLOAD_FORM_POST,
    `${prefixApi}/insert-log`,
    dataBody,
  );
};